import { render, staticRenderFns } from "./GenerateCollapse.vue?vue&type=template&id=745c5961&"
import script from "./GenerateCollapse.vue?vue&type=script&lang=js&"
export * from "./GenerateCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports